import React, { useEffect, useState } from 'react'
import Header from '../../../components/generals/header'
import stylesIndex from './../../../css/Index.module.css'
import store from '../../../reducer/store'
import styles from '../../../css/reports/Reports.module.css'
import { NavLink, useNavigate } from 'react-router-dom'
import { Button } from 'reactstrap'
import DataTableDemo from '../../../components/generals/datatables/datatable'
import { getData } from '../../../actions/servicesHttp'
import { useTranslation } from 'react-i18next'
import Loading from '../../../components/generals/loading'

export default function UsersReport () {
  const { t, ready } = useTranslation('usersReport')
  const { user } = store.getState()
  const role = user.roles
  const [urlUsers] = useState('users')
  const navigate = useNavigate()
  const [usersReport, setUsersReport] = useState(null)

  const columns = [
    { field: 'user', header: t('headers.one') },
    { field: 'name', header: t('headers.two') },
    { field: 'last', header: t('headers.three') },
    { field: 'phone', header: t('headers.four') },
    { field: 'email', header: t('headers.five') }
  ]

  const getUsers = async (url, set) => {
    const response = await getData(url, undefined, navigate)
    if (response?.status === 200) {
      const users = response.data
      // const users = response.data.filter((user) => user.id !== 1)
      set(users)
    } else {
      set([])
    }
  }

  useEffect(() => {
    if (ready) {
      getUsers(urlUsers, setUsersReport)
    }
  }, [ready])

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <div>
          <NavLink to="/mdm/reports">
              <Button variant="dark" className={styles.return_btn}>
                <i className="pi pi-arrow-circle-left" style={{ marginRight: '0.5rem' }}></i>
                {t('button')}
              </Button>
          </NavLink>
        </div>
        <div className={styles.div_dt}>
          {usersReport === null && <Loading color="primary" />}
            {usersReport !== null && <DataTableDemo
                data={usersReport}
                table="usersReport"
                editDataUser={null}
                exportsPdf={role?.reportsPage.exportPdfInReport}
                exportsCsv={role?.reportsPage.exportCsvInReport}
                actionDelete={false}
                editUsers={false}
                rowSelecteds={false}
                actionDashboard={false}
                rowStates={false}
                onSelecteds={null}
                reload={null}
                searchs={['user', 'name', 'last', 'email', 'phone']}
                columns={columns}
                namePdf={t('namePdf')}
            />}
        </div>
      </div>
    </div>
  )
}
